import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
const LayoutPageStickyContainer = memo(({
  bottom,
  className: classNameProp,
  children,
  left,
  right,
  style: styleProp,
  top,
  ...rest
}) => {
  const style = useMemo(() => ({
    "--cui-sticky-container-offset-left": left,
    "--cui-sticky-container-offset-right": right,
    "bottom": bottom,
    "top": top,
    ...styleProp
  }), [bottom, left, right, styleProp, top]);
  return /* @__PURE__ */ jsx("div", { ...rest, className: classNames(
    useComponentClassName("layout-page-sticky-container"),
    classNameProp
  ), style, children });
});
LayoutPageStickyContainer.displayName = "LayoutPageStickyContainer";
export {
  LayoutPageStickyContainer
};
//# sourceMappingURL=LayoutPageStickyContainer.js.map
